export const SAPPBOT_SET_USER = 'SAPPBOT_SET_USER';
export const SAPPBOT_RESET = 'SAPPBOT_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
